<template>
  
  <NuxtLink
    role="menuitem"
    class="flex items-center gap-[16px] h4 text-left p-[8px] hover:bg-gray-300 hover:text-gray-700 cursor-pointer"
    external>
      <img :src="btnicon" alt="AI Chat Icon" class="w4 h4" />
 
    <div class="flex items-center">
   
      <button @click="askTaiaClick">
        <span class="font-normal text-[14px] leading-[160%] tracking-normal align-middle whitespace-nowrap">
        Ask Taia a question
      </span>
      </button>
    </div>
  </NuxtLink>
  
</template>

  
<script setup lang="ts">
import btnicon from '@/assets/tgpt/images/ai-circle.png'
import eventBusGtm from '@/composables/eventBusGtm';


const askTaiaClick = () => {
    const screenName = document.title;
    eventBusGtm.emit('trackEvent', {
    event: 'Taia',
    button_name: 'search',
    screen_name: screenName,
  });
};

</script>